// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-705b47f6]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.log-details-pop[data-v-705b47f6] {\n  margin-bottom: 30px;\n}\n.log-details-pop .title[data-v-705b47f6] {\n  margin-bottom: 10px;\n}\n.log-details-pop .desc[data-v-705b47f6] {\n  margin-bottom: 10px;\n  color: #F56C6C;\n}", ""]);
// Exports
module.exports = exports;
